import {FJFontManager, FJFontBase64Manager} from 'fj-graph'
import $ from 'jquery'
import { v4 as uuid4 } from 'uuid'
import FJCanvasManager from "../FJCanvasManager";

/**
 * @description 核心库辅助函数
 */
let FJCoreUtil = (function () {

  const PRECISION_OFFSET = 0.01;
  let _audioContext = null;

  return {
    /**
     * @description 移除数组中的某个元素
     * @param array
     * @param item
     */
    removeFromArray: function (array, item) {
      if (!Array.isArray(array)) {
        console.error(new TypeError('ERR_ARGUMENTS'));
        return;
      }
      let index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
      }
    },

    /**
     * @description 取小数后几位
     * @param number
     * @param digit
     * @return {number}
     */
    toFixed: function (number, digit) {
      return parseFloat(Number(number).toFixed(digit));
    },

    /**
     * @description 内部尺寸自适应
     * @param {Object} outerSize
     * @param {number} outerSize.width
     * @param {number} outerSize.height
     * @param {Object} innerSize
     * @param {number} innerSize.width
     * @param {number} innerSize.height
     * @param {boolean} float
     * @return {{width: number, height: number}}
     */
    fitSize: function (outerSize, innerSize, float = false) {
      let r1 = innerSize.width / innerSize.height;
      let r2 = outerSize.width / outerSize.height;
      let offset = r1 - r2;
      let w;
      let h;

      if (Math.abs(offset) <= PRECISION_OFFSET) {
        return {...outerSize};
      } else if (offset > 0) {
        w = outerSize.width;
        h = w / r1;
      } else {
        h = outerSize.height;
        w = h * r1;
      }

      if (float) {
        return {
          width: w,
          height: h
        };
      } else {
        return {
          width: Math.floor(w),
          height: Math.floor(h)
        };
      }
    },

    /**
     * @description 外部尺寸自适应
     * @param {Object} outerSize
     * @param {number} outerSize.width
     * @param {number} outerSize.height
     * @param {Object} innerSize
     * @param {number} innerSize.width
     * @param {number} innerSize.height
     * @param {boolean} float
     * @return {{width: number, height: number}}
     */
    fillSize: function (outerSize, innerSize, float = false) {
      let r1 = innerSize.width / innerSize.height;
      let r2 = outerSize.width / outerSize.height;
      let offset = r1 - r2;
      let w;
      let h;

      if (Math.abs(offset) <= PRECISION_OFFSET) {
        return {...outerSize}
      } else if (offset > 0) {
        h = outerSize.height;
        w = h * r1;
      } else {
        w = outerSize.width;
        h = w / r1;
      }

      if (float) {
        return {
          width: w,
          height: h
        };
      } else {
        return {
          width: Math.floor(w),
          height: Math.floor(h)
        };
      }
    },

    /**
     * @description 触发元素事件
     * @param {Element} element
     * @param event
     */
    triggerEvent: function (element, event) {
      let e;
      if (document.createEvent) {
        e = document.createEvent("HTMLEvents");
        e.initEvent(event, true, true);
      } else {
        e = document.createEventObject();
        e.eventType = event;
      }

      e.eventName = event;

      if (document.createEvent) {
        element.dispatchEvent(e);
      } else {
        element.fireEvent("on" + e.eventType, e);
      }
    },

    /**
     * @description 在body上触发mousedown事件，用于取消其他二级展开的显示
     */
    triggerBodyMousedown: function () {
      this.triggerEvent(document.body, 'mousedown');
    },

    /**
     * @description 添加事件
     * @param {Element} element
     * @param {String} event
     * @param {function} handler
     */
    addEvent: function (element, event, handler) {
      if (!element) {
        return;
      }
      if (element.addEventListener) {
        element.addEventListener(event, handler);
      } else if (element.attachEvent) {
        element.attachEvent('on' + event, handler);
      }
    },

    /**
     * @description 移除事件
     * @param {Element} element
     * @param {String} event
     * @param {function} handler
     */
    removeEvent: function (element, event, handler) {
      if (!element) {
        return;
      }
      if (element.removeEventListener) {
        element.removeEventListener(event, handler);
      } else if (element.detachEvent) {
        element.detachEvent('on' + event, handler);
      }
    },

    /**
     * @description 返回一个中间值
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number}
     */
    valueOfInterval(value, min, max) {
      let result = 0;
      result = value < min ? min : value;
      result = result > max ? max : result;
      return result;
    },

    /**
     *
     * @param size
     * @param maxSize
     * @return {{width: number, height: number}}
     */
    adaptSizeWithMaxSize: function (size, maxSize) {
      let w = size.width
      let h = size.height;
      if (size.width > maxSize || size.height > maxSize) {
        let r = size.width / size.height;
        if (r >= 1) {
          w = maxSize;
          h = w / r;
        } else {
          h = maxSize;
          w = h * r;
        }
      }

      return {width: Math.ceil(w), height: Math.ceil(h)};
    },

    /**
     *
     * @param size
     * @param rotation
     * @return {any}
     */
    contentSizeByOrientation: function (size, rotation) {
      let outputSize = {...size};
      switch (rotation) {
        case 90:
        case 270:
          outputSize.width = size.height;
          outputSize.height = size.width;
          break;
        default:
      }
      return outputSize;
    },

    /**
     * @description 旋转canvas
     * @param canvas
     * @param originalSize
     * @param rotation
     */
    changeOrientation: function (canvas, originalSize, rotation) {
      let ctx = canvas.getContext('2d');
      switch (rotation) {
        case 0:
          break;
        case 90:
          ctx.transform(0, 1, -1, 0, originalSize.height, 0);
          break;
        case 180:
          ctx.transform(-1, 0, 0, -1, originalSize.width, originalSize.height);
          break;
        case 270:
          ctx.transform(0, -1, 1, 0, 0, originalSize.width);
          break;
        default:
          return;
      }
    },

    /**
     * @description 返回当前鼠标的位置
     * @param {Object} e
     * @return {{x: *, y: *}}
     */
    calcCursorPoint: function (e) {
      return {
        x: e.clientX,
        y: e.clientY,
      }
    },

    /**
     * @description 计算渲染的rect
     * @param {Object} relativeRect
     * @param {number} relativeRect.x
     * @param {number} relativeRect.y
     * @param {number} relativeRect.width
     * @param {number} relativeRect.height
     * @param viewSize
     * @param {number} viewSize.width
     * @param {number} viewSize.height
     * @return {{x: number, width: number, y: number, height: number}}
     */
    calcRenderRect: function (relativeRect, viewSize) {
      let {x, y, width, height} = relativeRect;
      return {
        x: Math.floor(x * viewSize.width),
        y: Math.floor(y * viewSize.height),
        width: Math.floor(width * viewSize.width),
        height: Math.floor(height * viewSize.height),
      }
    },

    /**
     * @description 计算渲染的相对rect
     * @param rect
     * @param viewSize
     * @return {{x: number, width: number, y: number, height: number}}
     */
    calcRelativeRect: function (rect, viewSize) {
      let {x, y, width, height} = rect;
      return {
        x: x / viewSize.width,
        y: y / viewSize.height,
        width: width / viewSize.width,
        height: height / viewSize.height,
      }
    },

    /**
     * @description 返回中心点坐标
     * @param rect
     * @return {{x: number, y: number}}
     */
    calcCenterRect: function (rect) {
      let {x, y, width, height} = rect;
      return {
        x: x + width / 2,
        y: y + height / 2
      }
    },

    /**
     * @description 将rect的中心与point对齐
     * @param {Object} rect
     * @param {number} rect.x
     * @param {number} rect.y
     * @param {number} rect.width
     * @param {number} rect.height
     * @param {Object} point
     * @param {number} point.x
     * @param {number} point.y
     * @return {{x: number, y: number}}
     */
    locationCenterToPoint: function (rect, point) {
      let {x, y} = this.calcCenterRect(rect);
      return {
        ...rect,
        x: rect.x - (x - point.x),
        y: rect.y - (y - point.y),
      }
    },

    /**
     * @description 计算元素尺寸
     * @param element
     * @return {{currentWidth: number, width: (*|jQuery), currentHeight: number, height: jQuery}}
     */
    calcElementSize: function (element) {
      let shouldAttachElement = !element.parentNode;
      if (shouldAttachElement) {
        $(document.body).append(element);
      }
      let {width, height} = element.getBoundingClientRect();
      /*
      width、height是不计算transform下的尺寸
      currentWidth、currentHeight是视图上的尺寸
       */
      let info = {
        width: $(element).width(),
        height: $(element).height(),
        currentWidth: width,
        currentHeight: height,
      };
      if (shouldAttachElement) {
        $(element).remove();
      }
      return info;
    },

    /**
     * @description 返回音频上下文
     * @return {AudioContext}
     */
    audioContext: function () {
      return _audioContext || (new (window.AudioContext || window.webkitAudioContext)());
    },

    /**
     * @description 点是否在某个区域内
     * @param {Object} point
     * @param {number} point.x
     * @param {number} point.y
     * @param {Object} rect
     * @param {number} rect.x
     * @param {number} rect.y
     * @param {number} rect.width
     * @param {number} rect.height
     * @return {boolean|boolean}
     */
    isPointInRect: function (point, rect) {
      return point.x >= rect.x && point.x <= rect.x + rect.width &&
        point.y >= rect.y && point.y <= rect.y + rect.height
    },

    /**
     * 获取音频上下文
     * @return {*}
     */
    getAudioContext: function () {
      if (_audioContext)
        return _audioContext;
      else {
        _audioContext = new (window.AudioContext || window.webkitAudioContext)();
        return _audioContext;
      }
    },

    /**
     * 获取音频采样率
     * @return {Number|boolean|number|ConstrainLongRange|LongRange|*}
     */
    getAudioSampleRate: function () {
      let sr = this.getAudioContext().sampleRate;
      return sr === 48000 ? 48000 : 44100;
    },

    /**
     * @description 解码音频数据
     * @param ctx
     * @param arrayBuffer
     * @return {Promise<any>}
     */
    decodeAudioData: function (ctx, arrayBuffer) {
      return new Promise((resolve, reject) => {
        ctx.decodeAudioData(arrayBuffer).then((data) => {
          resolve(data);
        }).catch((e) => {
          console.log(e);
          reject(e);
        });
      });
    },

    /**
     * @description 文件或blob转ArrayBuffer
     * @param source
     * @return {Promise<any>}
     */
    convertToArrayBuffer: function (source) {
      return new Promise((resolve, reject) => {
        // source is blob or blob url
        if (source === null) {
          reject(new Error("Can't convert null to ArrayBuffer!"));
        }
        if (typeof source === "string") { // blob url
          let xhr = new XMLHttpRequest();
          xhr.open('GET', source, true);
          xhr.responseType = 'arraybuffer';
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              resolve(null);
            }
          };
          xhr.onerror = () => {
            resolve(null);
          };
          xhr.ontimeout = () => {
            resolve(null);
          };

          xhr.send();
        } else {
          try {
            let fileReader = new FileReader();
            fileReader.onload = () => {
              resolve(fileReader.result);
            };
            fileReader.onerror = () => {
              resolve(null);
            };
            fileReader.readAsArrayBuffer(source);
          } catch (e) {
            console.log(e, source);
            resolve(null);
          }
        }
      });
    },

    /**
     * @description 返回字体对于bold、italic的支持
     * @param fontName
     * @return {{disableItalic: boolean, disableBold: boolean}}
     */
    fontStyleDisableData: function (fontName) {
      let item = FJFontManager.fontItemWithName(fontName);
      if (!item)
        return {
          disableBold: false,
          disableItalic: false,
        }

      let fontFamilyList = item.family;
      let style = {
        disableBold: false,
        disableItalic: false,
      };
      if (fontFamilyList.indexOf('n7') === -1) {
        style.disableBold = true;
      }
      if (fontFamilyList.indexOf('i4') === -1) {
        style.disableItalic = true;
      }
      return style;
    },

    /**
     * @description 返回字符宽度
     * @param string
     * @param fontName
     * @param fontSize
     * @param fontStyle
     * @param fontWeight
     * @param lineHeight
     * @return {{width: (*|jQuery), height: jQuery}}
     */
    getStringSize: function (string = '', fontName, fontSize, fontStyle = 'normal', fontWeight = 'normal', lineHeight = 'inherit') {
      let doc = document;
      let div = doc.createElement('div');
      $(div).css({
        position: 'absolute',
        top: 99999999,
        left: 99999999,
        opacity: 0,
        'font-family': fontName,
        'font-size': fontSize,
        'font-style': fontStyle,
        'font-weight': fontWeight,
        "white-space": "nowrap",
        lineHeight: lineHeight,
      }).html(string);
      $(doc.body).append(div);
      let size = {width: $(div).width(), height: $(div).height()};
      $(div).remove();
      div = null;
      return size;
    },

    /**
     * @description 向下求偶
     * @param num
     * @return {number}
     */
    even: function (num) {
      return Math.floor(num) % 2 === 0 ? Math.floor(num) : Math.floor(num) - 1;
    },

    /**
     * @description 创建svg
     * @param size
     * @return {SVGSVGElement}
     */
    getSvgWithForeignObject: function (size) {
      let xmlns = 'http://www.w3.org/2000/svg';
      let svg = document.createElementNS(xmlns, 'svg');
      let foreignObject = document.createElementNS(xmlns, 'foreignObject');
      svg.setAttributeNS(null, 'width', size.width);
      svg.setAttributeNS(null, 'height', size.height);
      foreignObject.setAttributeNS(null, 'width', size.width);
      foreignObject.setAttributeNS(null, 'height', size.height);
      foreignObject.setAttributeNS(null, 'x', 0);
      foreignObject.setAttributeNS(null, 'y', 0);
      let defs = document.createElement('defs');
      let styles = document.createElement('style');
      defs.appendChild(styles);
      svg.appendChild(defs);
      svg.appendChild(foreignObject);
      return svg;
    },

    /**
     * @description 插入字体到svg
     * @param svg
     * @param fontDataArr
     * @return {Promise<unknown>}
     */
    insertFontToSvg: function (svg, fontDataArr) {
      return new Promise(((resolve, reject) => {
        let styles = $(svg).find('style')[0];
        $(styles).text('');
        fontDataArr.forEach(({fontName, bold, italic, fontBase64}) => {
          let textNode = document.createTextNode("" +
            "* {box-sizing: border-box}" +
            " @font-face {font-family: \"" + fontName + "\";" +
            "font-style:" + (italic ? "italic;" : "normal;") +
            "font-weight:" + (bold ? "700;" : "400;") +
            "src: url(\"data:application/font-woff;charset=utf-8;base64," + fontBase64 + "\");}");
          $(styles).append(textNode);
        });
        this.svgToImage(svg, resolve, reject);
      }))
    },

    /**
     * @description svg转图片
     * @param svg
     */
    svgToImage: function (svg) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        image.onload = () => {
          resolve(image)
        };
        image.onerror = reject;
      })
    },

    cloneNodeAsync: async function (node, useImage) {
      let func = (cloneCanvas, canvas) => {
        cloneCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height);
        return cloneCanvas;
      };
      let imageFunc = function (canvas) {
        return new Promise((resolve, reject) => {
          let image = new Image();
          image.setAttribute('crossOrigin', 'anonymous');
          image.src = canvas.toDataURL();
          image.onload = function () {
            resolve(image);
          };
          image.onerror = () => {
            reject(image);
          };
        });
      };
      if (node.nodeName === 'CANVAS') {
        return func(node.cloneNode(true), node);
      } else {
        let clone = node.cloneNode(true);
        let canvases = $(node).find('canvas');
        let cloneCanvases = $(clone).find('canvas');
        let arr = [...canvases];
        let length = arr.length;
        for (let i = 0; i < length; i++) {
          if (useImage) {
            let c = arr[i];
            let cloneC = cloneCanvases[i];
            let image;
            let styleText = c.style.cssText;
            image = await imageFunc(c);
            image.style.cssText = styleText;
            if (image) {
              cloneC.parentNode.replaceChild(image, cloneC);
            }
          } else {
            func(cloneCanvases[i], arr[i]);
          }
        }
        return clone;
      }
    },

    /**
     * @description 渲染html到canvas
     * @param html
     * @param fontDatas
     * @return {Promise<element>}
     */
    htmlToCanvas: async function (html, fontDatas = []) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let size = html.getBoundingClientRect();
      canvas.width = size.width;
      canvas.height = size.height;
      try {
        let svg = this.getSvgWithForeignObject(size);
        let foreignObject = svg.querySelector('foreignObject');
        foreignObject.appendChild(await this.cloneNodeAsync(html, true));
        let fontDataArr = [];
        for (let i = 0; i < fontDatas.length; i++) {
          let fontData = fontDatas[i];
          let {fontName, bold, italic} = fontData;
          let base64 = await FJFontBase64Manager.getFontBase64(fontData);
          fontDataArr.push({
            fontName,
            bold,
            italic,
            fontBase64: base64
          });
        }
        let image = fontDataArr.length > 0 ? await this.insertFontToSvg(svg, fontDataArr)
          : await this.svgToImage(svg);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
      } catch (e) {
        console.log(e);
        throw e;
      }
      return canvas;
    },

    /**
     * @description 远端获取json
     * @param path
     * @return {Promise<any>}
     */
    fetchJson: function (path) {
      return fetch(path).then(response => response.json())
    },

    /**
     * @description 插入到某个元素之后
     * @param element
     * @param target
     */
    appendSibling: function (element, target) {
      target.parentNode.insertBefore(element, target.nextSibling);
    },

    /**
     * @description 绘制虚线
     * @param context
     * @param x1
     * @param y1
     * @param x2
     * @param y2
     * @param dashLength
     */
    drawDashedLine: function (context, x1, y1, x2, y2, dashLength = 4) {
      let startX = x1;
      let startY = y1;
      let endX = x2;
      let endY = y2;
      let {width, height} = context.canvas;
      let adsorptionLineWidth = 2;
      if(startY === 0 && endY === 0) {
        endY += adsorptionLineWidth / 2;
        startY += adsorptionLineWidth / 2;
      } else if(startY === height && endY === height) {
        endY -= adsorptionLineWidth /2;
        startY -= adsorptionLineWidth /2;
      } else if(startX === 0 && endX === 0) {
        startX += adsorptionLineWidth / 2;
        endX += adsorptionLineWidth / 2;
      } else if(startX === width && endX === width) {
        startX -= adsorptionLineWidth / 2;
        endX -= adsorptionLineWidth / 2;
      }
      context.setLineDash([dashLength]);
      context.lineWidth = adsorptionLineWidth;
      context.strokeStyle = 'rgba(191, 11, 247, 0.8)';
      context.beginPath();
      context.moveTo(startX, startY);
      context.lineTo(endX, endY);
      context.stroke();
    },

    /**
     * @description 生成id
     * @return {string}
     */
    createId() {
      return uuid4();
    },

    /**
     * @description 延时
     * @param {number} millisecond {毫秒}
     * @return {Promise<unknown>}
     */
    wait: function (millisecond = 300) {
      return new Promise((resolve) => {
        setTimeout(resolve, millisecond)
      })
    },

    /**
     * @public
     * @description 获取当前浏览器
     * @return {string}
     */
    getBrowser: function () {
      let Sys = {};
      let ua = navigator.userAgent.toLowerCase();
      let s;
      let isMobile = '';
      ((s = ua.match(/rv:([\d.]+)\) like gecko/))) ? Sys.ie = s[1] :
        ((s = ua.match(/msie ([\d.]+)/))) ? Sys.ie = s[1] :
          ((s = ua.match(/edge\/([\d.]+)/))) ? Sys.edge = s[1] :
            ((s = ua.match(/firefox\/([\d.]+)/))) ? Sys.firefox = s[1] :
              ((s = ua.match(/chrome\/([\d.]+)/))) ? Sys.chrome = s[1] :
                ((s = ua.match(/opera.([\d.]+)/))) ? Sys.opera = s[1] :
                  ((s = ua.match(/version\/([\d.]+).*safari/))) ? Sys.safari = s[1] : 0;

      if (ua.match(/mobile/)) {
        (isMobile = '.Mobile');
      }

      if (Sys.ie) return "IE" + isMobile;
      if (Sys.edge) return "Edge" + isMobile;
      if (Sys.firefox) return "FF" + isMobile;
      if (Sys.chrome) return "Chrome" + isMobile;
      if (Sys.opera) return "Opera" + isMobile;
      if (Sys.safari) return "Safari" + isMobile;
    },

    renderVideoToCanvasWithInfo: function (canvas, video, videoInfo, options) {
      let {rotation} = videoInfo;
      let ctx = canvas.getContext('2d');
      if (this.getBrowser() === 'FF' && (rotation === 90 || rotation === 270)) {
        let middleCanvas = FJCanvasManager.getCanvas();
        middleCanvas.width = canvas.height;
        middleCanvas.height = canvas.width;
        middleCanvas.getContext('2d').drawImage(video, 0, 0, middleCanvas.width, middleCanvas.height);
        FJCoreUtil.changeOrientation(canvas, middleCanvas, rotation);
        if (options && options.clipRect) {
          let {x, y, width, height} = options.clipRect;
          let rx = x / video.videoWidth;
          let ry = y / video.videoHeight;
          let rWidth = width / video.videoWidth;
          let rHeight = height / video.videoHeight;
          ctx.drawImage(middleCanvas,
            rx * middleCanvas.width,
            ry * middleCanvas.height,
            rWidth * middleCanvas.width,
            rHeight * middleCanvas.height, 0, 0, middleCanvas.width, middleCanvas.height);
        } else {
          ctx.drawImage(middleCanvas, 0, 0, middleCanvas.width, middleCanvas.height);
        }
        FJCanvasManager.releaseCanvas(middleCanvas);
      } else {
        if (options && options.clipRect) {
          let {x, y, width, height} = options.clipRect;
          ctx.drawImage(video, x, y, width, height, 0, 0, canvas.width, canvas.height);
        } else {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
      }
    },

    /**
     * @description 设置画布平滑度
     * @param canvas
     */
    smoothCanvas: function (canvas) {
      let ctx = canvas.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
    },
  }
})();

export default FJCoreUtil;
